module.exports = __webpack_public_path__ + "img/man.74f359d.svg";